<div class="modal fade" id="loadsModal" tabindex="-1" role="dialog" data-bs-backdrop="static"
  aria-labelledby="loadsModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" style="margin-top:25%">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="loadsModalLabel">Loads</h5>
        <button type="button" #closeButton class="btn-close btn-sm" data-bs-dismiss="modal" aria-label="Close"
          data-bs-target="loadsModal" *ngIf="!showDelete" (click)="closePopup()"></button>
      </div>

      <div class="modal-body" style="max-height: 600px; padding: inherit;" #tableContainer id="originHeader"
        *ngIf="!showDelete">
        <div class="table-container">
          <table [ngClass]="{'tbl-non-breakout': loadsData?.[0]?.loadBreakout != '1'}"
            *ngIf="loadsData && loadsData?.length > 0">
            <thead>
              <tr>
                <th *ngIf="loadsData?.[0]?.loadBreakout == '1'">
                  <input type="checkbox" [(ngModel)]="selectAll" [ngModelOptions]="{standalone: true}" (change)="toggleSelectAll()" class="select-all-box" />
                </th>
                <th *ngIf="loadsData?.[0]?.loadBreakout == '1'" style="min-width: 100px;">Load Date</th>
                <th *ngIf="loadsData?.[0]?.loadBreakout ==  '1'">Day</th>
                <th *ngIf="loadsData?.[0]?.loadBreakout == '1'" style="min-width: 106px;">Delivery Date</th>
                <th *ngIf="loadsData?.[0]?.loadBreakout == '1'">Load #</th>
                <th *ngIf="loadsData?.[0]?.loadBreakout == '1'">Unload #</th>
                <th>Ticket #</th>
                <th>PA</th>
                <th>Dlvd</th>
                <th>FS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of loadsData">
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'">
                  <div class="d-flex justify-content-center align-items-center me-2">
                    <input type="checkbox" [(ngModel)]="row.isSelected" [ngModelOptions]="{standalone: true}" (change)="checkSelectAll()"
                      style="margin-right: 4px;" />

                    <i class="fa-solid fa-trash fa-lg text-primary mx-1" (click)="deleteLoadConfirmation(row)"></i>

                    <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                      attr.data-bs-target="#{{loadBankApplyFormId}}" title="find load number"
                      (click)="openLoadBank(row.dispatchId, row.loadId, 0)">
                      <i class="fa-solid fa-upload fa-lg text-primary mx-1"></i>
                    </a>
                    <a class="ms-2" href="#" tabindex="-1" data-bs-toggle="modal"
                      attr.data-bs-target="#{{loadBankApplyFormId}}" title="find load number"
                      (click)="openLoadBank(row.dispatchId, row.loadId, 1)">
                      <i class="fa-solid fa-download fa-lg text-primary mx-1"></i>
                    </a>
                  </div>
                </td>
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'">{{ row.useDeliveryDate == false ? row.pickupDate : ""}}</td>
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'">{{ row.useDeliveryDate == false && row.pickupDate ?  getDay(row.pickupDate) : "" }}</td>
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'">{{ row.useDeliveryDate == true ? row.deliveryDate : "" }}</td>
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'"> <input type="text"
                    class="form-control form-control-sm custom-input-bg" name="loadNumber" (change)="updateLoad(row)"
                    [(ngModel)]="row.loadNumber" [ngModelOptions]="{standalone: true}" style="width: 100px; background-color: #FFF2CC" /></td>
                <td *ngIf="loadsData?.[0]?.loadBreakout == '1'"> <input type="text"
                    class="form-control form-control-sm custom-input-bg" name="unLoadNumber" (change)="updateLoad(row)"
                    [(ngModel)]="row.unLoadNumber" [ngModelOptions]="{standalone: true}" style="width: 100px; background-color: #FFF2CC" /></td>
                <td><input type="text" class="form-control form-control-sm custom-input-bg" name="ticketNumber"
                    (change)="updateLoad(row)" [(ngModel)]="row.ticketNumber" [ngModelOptions]="{standalone: true}" [ngStyle]="{
                                      'width': loadsData?.[0]?.loadBreakout == '1' ?  '100px' : 'fit-content',
                                      'background-color': '#FFF2CC'
                                    }" /></td>
                <td><input type="checkbox" [(ngModel)]="row.preAdvise" [ngModelOptions]="{standalone: true}" [checked]="row.preAdvise"
                    (change)="updateLoad(row)" /></td>
                <td><input type="checkbox" [(ngModel)]="row.delivered" [ngModelOptions]="{standalone: true}" [checked]="row.delivered"
                    (change)="updateLoad(row)" /></td>
                <td><input type="checkbox" [(ngModel)]="row.finalSettled" [ngModelOptions]="{standalone: true}" [checked]="row.finalSettled"
                    (change)="updateLoad(row)" /></td>
              </tr>
            </tbody>
          </table>
          <mat-card _ngcontent-ng-c2689411729="" class="mat-mdc-card mdc-card card"
            *ngIf="loadsData && loadsData?.length == 0" style="width: 100%; max-width: 600px;"><mat-card-content
              class="mat-mdc-card-content">No loads available for
              this dispatch.</mat-card-content></mat-card>
        </div>
      </div>

      <div class="modal-body" style="max-height: 600px;overflow-y: auto;height: auto;" id="originHeader"
        *ngIf="showDelete">
        <div class="col-12 mb-2 px-3">
          <div class="mb-4">
            Are you sure you want to delete the load with load date {{selectedLoadData.pickupDate | date:
            'MM/dd/yyyy'}}?
          </div>
          <div class="row justify-content-center">
            <button type="button" class="btn btn-sm btn-danger me-2" style="width: 120px;" (click)="deleteLoad()"
              *ngIf="formStatus == FormStatus.Normal">Confirm Delete</button>
            <button type="button" class="btn btn-sm btn-danger me-2" style="width: 120px;" disabled
              *ngIf="formStatus == FormStatus.Deleting">
              <span class="spinner-border spinner-border-sm me-1"></span>
              <span>Deleting...</span>
            </button>
            <button type="button" class="btn btn-sm btn-secondary" style="width: 120px;"
              [disabled]="formStatus == FormStatus.Deleting" (click)="showDelete = false; showForm = true">Cancel
              Delete</button>
          </div>
        </div>
      </div>

      <div class="modal-body" style="max-height: 600px;overflow-y: auto;height: auto;" id="originHeader"
        *ngIf="showLoadBankApplyForm">

      </div>
    </div>
  </div>
</div>

<load-bank-apply [parameters]="loadBankApplyParameters" [isMobile]="true" [loadBankApplyFormId]="loadBankApplyFormId"
  (loadBankApplyComplete)="loadBankApplyComplete($event)"></load-bank-apply>